// Image utility functions and constants

// Available local images
export const localImages = {
  ai: '/images/ai.webp',
  awards: '/images/awards.webp',
  globalcompetition: '/images/globalcompetition.jpg',
  experts: '/images/experts.webp',
  realworldproblems: '/images/realworldproblems.jpg',
}

// Category images mapping (using local images as fallbacks)
export const categoryImages = {
  'Computer Vision': '/images/ai.webp',
  'Natural Language Processing': '/images/ai.webp',
  'Machine Learning': '/images/ai.webp',
  'Deep Learning': '/images/ai.webp',
  'Reinforcement Learning': '/images/ai.webp',
  'Data Science': '/images/ai.webp',
  'Robotics': '/images/realworldproblems.jpg',
  'Speech Recognition': '/images/ai.webp',
  'Generative AI': '/images/ai.webp',
  'Time Series': '/images/ai.webp',
  'Building Technology': '/images/realworldproblems.jpg',
  'Smart Buildings': '/images/realworldproblems.jpg',
  'Energy Optimization': '/images/realworldproblems.jpg',
  'Facility Management': '/images/realworldproblems.jpg',
}

// Fallback images
export const fallbackImages = {
  category: '/images/ai.webp',
  hero: '/images/ai.webp',
  challenge: '/images/ai.webp',
  user: '/images/experts.webp',
}

// Hero images
export const heroImages = {
  main: '/images/ai.webp',
  challenges: '/images/globalcompetition.jpg',
  leaderboard: '/images/awards.webp',
  about: '/images/experts.webp',
  dashboard: '/images/ai.webp',
}

// Get category image with fallback
export const getCategoryImage = (category) => {
  return categoryImages[category] || fallbackImages.category
}

// Get hero image with fallback
export const getHeroImage = (page) => {
  return heroImages[page] || fallbackImages.hero
}

// Generate placeholder image URL using local images
export const getPlaceholderImage = (width = 400, height = 300, keywords = '') => {
  // Check if we have a local image that matches the keywords
  const keywordArray = keywords.toLowerCase().split(',').map(k => k.trim())
  
  // Map keywords to local images
  for (const keyword of keywordArray) {
    if (keyword.includes('ai') || keyword.includes('artificial-intelligence') || keyword.includes('technology') || keyword.includes('innovation')) {
      return localImages.ai
    }
    if (keyword.includes('award') || keyword.includes('trophy') || keyword.includes('success') || keyword.includes('recognition') || keyword.includes('competition') || keyword.includes('leaderboard')) {
      return localImages.awards
    }
    if (keyword.includes('global') || keyword.includes('world') || keyword.includes('network') || keyword.includes('participants')) {
      return localImages.globalcompetition
    }
    if (keyword.includes('expert') || keyword.includes('community') || keyword.includes('collaboration') || keyword.includes('team') || keyword.includes('portrait') || keyword.includes('professional')) {
      return localImages.experts
    }
    if (keyword.includes('real-world') || keyword.includes('engineering') || keyword.includes('building') || keyword.includes('smart-building') || keyword.includes('facility') || keyword.includes('mechanical') || keyword.includes('electrical')) {
      return localImages.realworldproblems
    }
  }
  
  // Fallback to AI image for general technology content
  return localImages.ai
}

// Get specific local image
export const getLocalImage = (imageName) => {
  return localImages[imageName] || localImages.ai
}

// Generate gradient background for categories
export const getCategoryGradient = (category) => {
  const gradients = {
    'Computer Vision': 'from-blue-500 to-purple-600',
    'Natural Language Processing': 'from-green-500 to-teal-600',
    'Machine Learning': 'from-orange-500 to-red-600',
    'Deep Learning': 'from-purple-500 to-pink-600',
    'Reinforcement Learning': 'from-indigo-500 to-blue-600',
    'Data Science': 'from-yellow-500 to-orange-600',
    'Robotics': 'from-gray-500 to-gray-700',
    'Speech Recognition': 'from-pink-500 to-rose-600',
    'Generative AI': 'from-cyan-500 to-blue-600',
    'Time Series': 'from-emerald-500 to-green-600',
  }
  
  return gradients[category] || 'from-gray-500 to-gray-600'
}